import TransfersListItem, { TransfersListItemPhone } from "./styles";

export { TransfersListItemPhone };
export default TransfersListItem;
